import classNames from 'classnames'
import { ReactComponent as CloseIcon } from '../icons/close.svg'

export default function CloseButton({ onClick, className, ...rest }) {
  return (
    <button onClick={onClick} className={classNames('p-2 rounded-lg text-primary bg-secondary', className)} {...rest}>
      <CloseIcon className='w-4 h-4' />
    </button>
  )
}